var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONObjectResolver } from "graphql-scalars";
import { Field, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { Resource } from "./Resource.js";
let AuditLogNode = class AuditLogNode extends Resource {
    userId;
    subjectGlobalId;
    id;
    summary;
    details;
    createdAt;
    text() {
        return this.summary;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
    getUniqueId() {
        return this.id.id;
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], AuditLogNode.prototype, "id", void 0);
__decorate([
    Field(() => String),
    __metadata("design:type", String)
], AuditLogNode.prototype, "summary", void 0);
__decorate([
    Field(() => JSONObjectResolver, { nullable: true }),
    __metadata("design:type", Object)
], AuditLogNode.prototype, "details", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Function)
], AuditLogNode.prototype, "createdAt", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], AuditLogNode.prototype, "text", null);
AuditLogNode = __decorate([
    ObjectType({ implements: [Node] })
], AuditLogNode);
export { AuditLogNode };
//# sourceMappingURL=AuditLog.js.map